// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2vE8R","wrapper":"Header_wrapper__b1sr_","buttons":"Header_buttons__20n8o","button":"Header_button__wweSh","logo":"Header_logo__LP4QD"};